import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
export default function PrivacyPolicy() {
  return (
    <>
     <div className="py-5" style={{ background: "#f9f9f9", marginTop:"6rem", minHeight: "100vh" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12} sm={12}>
            <div className="bg-white p-4 p-md-5 rounded shadow">
              <h1 className="mb-4 text-center">Privacy Policy  V Hotel The Grand Shoba</h1>

              {/* <p>
                Welcome to our Privacy Policy page. We respect your privacy and are committed to protecting your personal data.
              </p> */}

              <h5 className="mt-4">1. Introduction</h5>
              <p>
              V Hotel The Grand Shoba our respects your privacy and is committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website or make a reservation using Razorpay.
              </p>
              <h5 className="mt-4">2. Information We Collect</h5>
              <p>
                When you use our website or make a booking, we may collect the following information:
              </p>
                <p>
                  Full Name <br />
                Contact Number <br />
                Email Address <br/>
                ID Proof Details (if submitted during booking)  <br/>
                Payment details (processed via Razorpay – we do not store card details) <br/>
                </p>

              <h5 className="mt-4"> 3. How We Use Your Information We use the collected data to:</h5>
              <p>
               Process and confirm bookings

Communicate with you regarding your stay

Send payment confirmations and invoices

Improve our website and services

Ensure compliance with applicable laws and regulations

              </p>

              <h5 className="mt-4">4. Sharing of Data</h5>
              <p>
                We do not sell or rent your personal data to third parties. <br/>
                We may share your data with: <br/>
                Razorpay for processing payments

Government authorities, if legally required

Internal teams for service delivery and support

              </p>
              

              <h5 className="mt-4">5. Razorpay & Third-Party Payment Gateways</h5>
              <p>
                We use Razorpay to handle online payments securely. Your payment details (like card number, UPI, etc.) are encrypted and processed directly through Razorpay’s secure system. We do not store this sensitive information. <br />
                Refer to Razorpay’s Privacy Policy for more on how your data is managed on their end.

              </p>

              <h5 className="mt-4">6. Data Security</h5>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, or misuse. However, no system can be completely secure, and we cannot guarantee absolute security.
              </p>

              <h5 className="mt-4">7. Cookies</h5>
              <p>
                We may use cookies to enhance user experience and collect data on website usage. You can disable cookies through your browser settings if preferred.
              </p>

              <h5 className="mt-4">8. Data Retention</h5>
              <p>
               We retain personal data only for as long as necessary to: <br />
               Fulfill your booking

Comply with legal obligations

Resolve disputes

Enforce our policies
              </p>

              <h5 className="mt-4"> 9. Your Rights You may request to:</h5>
              <p>
             Access the data we hold about you

Correct or update your personal information

Delete your data (where legally applicable)

To make such requests, please email us at info@vhotelthegrandshoba.com
              </p>

              <h5 className="mt-4">10. Changes to This Privacy Policy</h5>
              <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date.
              </p>

              <h5 className="mt-4">11. Contact Usy</h5>
              <p>
              For any questions or concerns about this Privacy Policy, contact us: <br />
                  Email: info@vhotelthegrandshoba.com,  <br />
                  Phone:  +91 9811226576 ,
                  +91 9811320209


              </p>

              <p className="mt-4 text-muted text-center">
                Last updated: May 2025
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  )
}
